import script from "./TableRowData.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableRowData.vue?vue&type=script&setup=true&lang=ts"

import "./TableRowData.vue?vue&type=style&index=0&id=5ed6160f&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed6160f"]])

export default __exports__